<template>
  <div>
    <!-- <pre>{{this.temp[4]}}</pre> -->
    <!--   {{popupActive5}} -->
    <!-- {{ this.chartData2 }} -->
    <!-- <pre>{{ dataA }}</pre> -->
    <!-- <pre>{{ temp[0] }}</pre> -->
    <!-- {{ dataGraph1 }} -->
    <!-- <pre>{{this.sensorKhonKaen}}</pre>
    <div v-for="i in sensorRojana" :key="i">{{i.location}}</div> -->
    <!-- <div v-for="i in sensorKhonKaen" :key="i">{{i.id}}</div> -->
    <!-- <pre>{{ test }}</pre> -->
    <!-- <pre>{{ test }}</pre> -->
    <!-- {{ this.labels }}{{ this.labels8 }} -->
    <!-- <div>dataGraph1 : {{ this.dataGraph1 }}</div>
    <div>dataGraph2 : {{ this.dataGraph2 }}</div>
    <div>dataGraph3 : {{ this.dataGraph3 }}</div>
    <div>dataGraph4 : {{ this.dataGraph4 }}</div> -->
    <!-- <div class="flex-container">
      <div class="flex-item-left">1</div>
      <div class="flex-item-right">2</div>
    </div> -->
    <vs-card style="border-radius: 20px">
      <div class="mt-2" slot="header">
        <vs-row id="center">
          <h3 class="headerText text-left">Graph Visualization</h3>
        </vs-row>
      </div>
      <br />
      <vs-row vs-w="12">
        <vs-col class="padding0" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
          <div class="container">
            <vs-row>
              <div>
                <h4 class="card-title">
                  Graph 1 Location : {{ selectMapName[0] }}
                </h4>
                <!-- <h5 class="card-subtitle text-muted font-weight-normal">
                  Mode : {{selectMap1}}
                </h5> -->
              </div>
              <vs-spacer />
              <span>
                <vs-icon @click="popupActive1 = true" icon="settings"></vs-icon>
              </span>
            </vs-row>
            <div class="flex-container">
              <div class="flex-item-left">
                <lineChart :width="wGraph" :height="300" :chartData="this.chartData1" :options="this.options1" />
              </div>
              <div class="flex-item-right">
                <div class="mt-4 carddetail">
                  <h4 style="font-size: 0.8rem">Temperature</h4>
                  <br />
                  <h3 style="color: #ffde3d">
                    <b>{{ temp[0].avgValTemp }}°C</b>
                  </h3>
                  <br />
                  <br />
                  <h4 style="font-size: 0.8rem">Humidity</h4>
                  <br />
                  <h3 style="color: #2ba0ff">
                    <b>{{ temp[0].avgValHumid }}%</b>
                  </h3>
                </div>
              </div>
            </div>
            <vs-row>
              <!-- <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="9"
                vs-sm="12"
                vs-xs="12"
              >
                <lineChart
                  :width="wGraph"
                  :height="300"
                  :chartData="this.chartData1"
                  :options="this.options1"
                />
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="3"
                vs-sm="12"
                vs-xs="12"
              >
                <vs-card
                  style="
                    height: 80%;
                    margin: 10%;
                    border-radius: 10%;
                    text-align: center;
                  "
                  class="mt-4"
                >
                  <h4 style="font-size: 0.8rem">Temperature</h4>
                  <br />
                  <h3 style="color: #ffde3d">
                    <b>{{ temp[0].avgValTemp }}°C</b>
                  </h3>
                  <br />
                  <br />
                  <h4 style="font-size: 0.8rem">Humidity</h4>
                  <br />
                  <h3 style="color: #2ba0ff">
                    <b>{{ temp[0].avgValHumid }}%</b>
                  </h3>
                </vs-card>
              </vs-col> -->
              <vs-row vs-align="flex-start" class="mt-2" vs-type="flex" vs-justify="center" vs-w="12">
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                  <div align="center">
                    <p style="color: #ff006a" class="mb-1">Min Temp</p>
                    <p>{{ temp[0].minValTemp }}°C</p>
                  </div>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                  <div align="center">
                    <p style="color: #d400ff" class="mb-1">Max Temp</p>
                    <p>{{ temp[0].maxValTemp }}°C</p>
                  </div>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                  <div align="center">
                    <p style="color: #ff006a" class="mb-1">Min Humidity</p>
                    <p>{{ temp[0].minValHumid }}%</p>
                  </div>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                  <div align="center">
                    <p style="color: #d400ff" class="mb-1">Max Humidity</p>
                    <p>{{ temp[0].maxValHumid }}%</p>
                  </div>
                </vs-col>
              </vs-row>
            </vs-row>
          </div>
        </vs-col>
        <vs-col class="padding0" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
          <div class="container">
            <vs-row>
              <div>
                <h4 class="card-title">
                  Graph 2 Location : {{ selectMapName[1] }}
                </h4>
                <!-- <h5 class="card-subtitle text-muted font-weight-normal">
                  Mode : {{selectMap1}}
                </h5> -->
              </div>
              <vs-spacer />
              <span>
                <vs-icon @click="popupActive2 = true" icon="settings"></vs-icon>
              </span>
            </vs-row>

            <!-- <vs-row>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="9"
                vs-sm="12"
                vs-xs="12"
              >
                <lineChart
                  :width="wGraph"
                  :height="300"
                  :chartData="this.chartData2"
                  :options="this.options2"
                />
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="3"
                vs-sm="12"
                vs-xs="12"
              >
                <vs-card
                  style="
                    height: 80%;
                    margin: 10%;
                    border-radius: 10%;
                    text-align: center;
                  "
                  class="mt-4"
                >
                  <h4 style="font-size: 0.8rem">Temperature</h4>
                  <br />
                  <h3 style="color: #ffde3d">
                    <b>{{ temp[1].avgValTemp }}°C</b>
                  </h3>
                  <br />
                  <br />
                  <h4 style="font-size: 0.8rem">Humidity</h4>
                  <br />
                  <h3 style="color: #2ba0ff">
                    <b>{{ temp[1].avgValHumid }}%</b>
                  </h3>
                </vs-card>
              </vs-col>
            </vs-row> -->

            <div class="flex-container">
              <div class="flex-item-left">
                <lineChart :width="wGraph" :height="300" :chartData="this.chartData2" :options="this.options2" />
              </div>
              <div class="flex-item-right">
                <div class="mt-4 carddetail">
                  <h4 style="font-size: 0.8rem">Temperature</h4>
                  <br />
                  <h3 style="color: #ffde3d">
                    <b>{{ temp[1].avgValTemp }}°C</b>
                  </h3>
                  <br />
                  <br />
                  <h4 style="font-size: 0.8rem">Humidity</h4>
                  <br />
                  <h3 style="color: #2ba0ff">
                    <b>{{ temp[1].avgValHumid }}%</b>
                  </h3>
                </div>
              </div>
            </div>
            <vs-row vs-align="flex-start" class="mt-2" vs-type="flex" vs-justify="center" vs-w="12">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                <div align="center">
                  <p style="color: #ff006a" class="mb-1">Min Temp</p>
                  <p>{{ temp[1].minValTemp }}°C</p>
                </div>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                <div align="center">
                  <p style="color: #d400ff" class="mb-1">Max Temp</p>
                  <p>{{ temp[1].maxValTemp }}°C</p>
                </div>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                <div align="center">
                  <p style="color: #ff006a" class="mb-1">Min Humidity</p>
                  <p>{{ temp[1].minValHumid }}%</p>
                </div>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                <div align="center">
                  <p style="color: #d400ff" class="mb-1">Max Humidity</p>
                  <p>{{ temp[1].maxValHumid }}%</p>
                </div>
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12">
        <vs-col class="padding0" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
          <div class="container">
            <vs-row>
              <div>
                <h4 class="card-title">
                  Graph 3 Location : {{ selectMapName[2] }}
                </h4>
                <!-- <h5 class="card-subtitle text-muted font-weight-normal">
                  Mode : {{selectMap1}}
                </h5> -->
              </div>
              <vs-spacer />
              <span>
                <vs-icon @click="popupActive3 = true" icon="settings"></vs-icon>
              </span>
            </vs-row>

            <!-- <vs-row>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="9"
                vs-sm="12"
                vs-xs="12"
              >
                <lineChart
                  :width="wGraph"
                  :height="300"
                  :chartData="this.chartData3"
                  :options="this.options3"
                />
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="3"
                vs-sm="12"
                vs-xs="12"
              >
                <vs-card
                  style="
                    height: 80%;
                    margin: 10%;
                    border-radius: 10%;
                    text-align: center;
                  "
                  class="mt-4"
                >
                  <h4 style="font-size: 0.8rem">Temperature</h4>
                  <br />
                  <h3 style="color: #ffde3d">
                    <b>{{ temp[2].avgValTemp }}°C</b>
                  </h3>
                  <br />
                  <br />
                  <h4 style="font-size: 0.8rem">Humidity</h4>
                  <br />
                  <h3 style="color: #2ba0ff">
                    <b>{{ temp[2].avgValHumid }}%</b>
                  </h3>
                </vs-card>
              </vs-col>
            </vs-row> -->
            <div class="flex-container">
              <div class="flex-item-left">
                <lineChart :width="wGraph" :height="300" :chartData="this.chartData3" :options="this.options3" />
              </div>
              <div class="flex-item-right">
                <div class="mt-4 carddetail">
                  <h4 style="font-size: 0.8rem">Temperature</h4>
                  <br />
                  <h3 style="color: #ffde3d">
                    <b>{{ temp[2].avgValTemp }}°C</b>
                  </h3>
                  <br />
                  <br />
                  <h4 style="font-size: 0.8rem">Humidity</h4>
                  <br />
                  <h3 style="color: #2ba0ff">
                    <b>{{ temp[2].avgValHumid }}%</b>
                  </h3>
                </div>
              </div>
            </div>
            <vs-row vs-align="flex-start" class="mt-2" vs-type="flex" vs-justify="center" vs-w="12">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                <div align="center">
                  <p style="color: #ff006a" class="mb-1">Min Temp</p>
                  <p>{{ temp[2].minValTemp }}°C</p>
                </div>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                <div align="center">
                  <p style="color: #d400ff" class="mb-1">Max Temp</p>
                  <p>{{ temp[2].maxValTemp }}°C</p>
                </div>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                <div align="center">
                  <p style="color: #ff006a" class="mb-1">Min Humidity</p>
                  <p>{{ temp[2].minValHumid }}%</p>
                </div>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                <div align="center">
                  <p style="color: #d400ff" class="mb-1">Max Humidity</p>
                  <p>{{ temp[2].maxValHumid }}%</p>
                </div>
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
        <vs-col class="padding0" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
          <div class="container">
            <vs-row>
              <div>
                <h4 class="card-title">
                  Graph 4 Location : {{ selectMapName[3] }}
                </h4>
                <!-- <h5 class="card-subtitle text-muted font-weight-normal">
                  Mode : {{selectMap1}}
                </h5> -->
              </div>
              <vs-spacer />
              <span>
                <vs-icon @click="popupActive4 = true" icon="settings"></vs-icon>
              </span>
            </vs-row>

            <!-- <vs-row>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="9"
                vs-sm="12"
                vs-xs="12"
              >
                <lineChart
                  :width="wGraph"
                  :height="300"
                  :chartData="this.chartData4"
                  :options="this.options4"
                />
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="3"
                vs-sm="12"
                vs-xs="12"
              >
                <vs-card
                  style="
                    height: 80%;
                    margin: 10%;
                    border-radius: 10%;
                    text-align: center;
                  "
                  class="mt-4"
                >
                  <h4 style="font-size: 0.8rem">Temperature</h4>
                  <br />
                  <h3 style="color: #ffde3d">
                    <b>{{ temp[3].avgValTemp }}°C</b>
                  </h3>
                  <br />
                  <br />
                  <h4 style="font-size: 0.8rem">Humidity</h4>
                  <br />
                  <h3 style="color: #2ba0ff">
                    <b>{{ temp[3].avgValHumid }}%</b>
                  </h3>
                </vs-card>
              </vs-col>
            </vs-row> -->
            <div class="flex-container">
              <div class="flex-item-left">
                <lineChart :width="wGraph" :height="300" :chartData="this.chartData4" :options="this.options4" />
              </div>
              <div class="flex-item-right">
                <div class="mt-4 carddetail">
                  <h4 style="font-size: 0.8rem">Temperature</h4>
                  <br />
                  <h3 style="color: #ffde3d">
                    <b>{{ temp[3].avgValTemp }}°C</b>
                  </h3>
                  <br />
                  <br />
                  <h4 style="font-size: 0.8rem">Humidity</h4>
                  <br />
                  <h3 style="color: #2ba0ff">
                    <b>{{ temp[3].avgValHumid }}%</b>
                  </h3>
                </div>
              </div>
            </div>
            <vs-row vs-align="flex-start" class="mt-2" vs-type="flex" vs-justify="center" vs-w="12">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                <div align="center">
                  <p style="color: #ff006a" class="mb-1">Min Temp</p>
                  <p>{{ temp[3].minValTemp }}°C</p>
                </div>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                <div align="center">
                  <p style="color: #d400ff" class="mb-1">Max Temp</p>
                  <p>{{ temp[3].maxValTemp }}°C</p>
                </div>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                <div align="center">
                  <p style="color: #ff006a" class="mb-1">Min Humidity</p>
                  <p>{{ temp[3].minValHumid }}%</p>
                </div>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                <div align="center">
                  <p style="color: #d400ff" class="mb-1">Max Humidity</p>
                  <p>{{ temp[3].maxValHumid }}%</p>
                </div>
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
      </vs-row>
      <!-- <vs-row vs-w="12">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="12"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-row>
            <h4 class="card-title">Graph 5</h4>
            <vs-spacer />
            <span>
              <vs-icon @click="popupActive5 = true" icon="settings"></vs-icon>
            </span>
            <vs-spacer />
            <vs-select
              class="selectExample"
              multiple
              @change="fillData(select_option)"
              v-model="select_option"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in options_graph"
              />
            </vs-select>
            <div class="mt-3" style="position: relative; width: 100%">
              <lineChart
                :height="370"
                :chartData="this.chartData5"
                :options="this.options5"
              />
            </div>

            <div style="position: relative; width: 100%">
              <div>
                <canvas id="planet-chart"></canvas>
              </div>
            </div>
          </vs-row>
        </vs-col>
      </vs-row>
      <br />
      <vs-row vs-w="12">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-sm="3"
          vs-w="2"
        >
          <div align="center">
            <p style="color: #ff006a" class="mb-1">Min Temp</p>
            <p>{{ temp[4].minValTemp }}°C</p>
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-sm="3"
          vs-w="2"
        >
          <div align="center">
            <p style="color: #d400ff" class="mb-1">Max Temp</p>
            <p>{{ temp[4].maxValTemp }}°C</p>
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-sm="3"
          vs-w="2"
        >
          <div align="center">
            <p style="color: #ff006a" class="mb-1">Min Humidity</p>
            <p>{{ temp[4].minValHumid }}%</p>
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-sm="3"
          vs-w="2"
        >
          <div align="center">
            <p style="color: #d400ff" class="mb-1">Max Humidity</p>
            <p>{{ temp[4].maxValHumid }}%</p>
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-sm="12"
          vs-w="4"
        >
          <vs-card style="border-radius: 20px">
            <vs-row class="mb-1">
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="6"
              >
                <h4 style="font-size: 0.8rem">Temperature</h4>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="6"
              >
                <h4 style="font-size: 0.8rem">Humidity</h4>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="6"
              >
                <h3 style="color: #ffde3d">
                  <b>{{ temp[4].avgValTemp }}°C</b>
                </h3>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="6"
              >
                <h3 style="color: #2ba0ff">
                  <b>{{ temp[4].avgValHumid }}%</b>
                </h3>
              </vs-col>
            </vs-row>
          </vs-card>
        </vs-col>
      </vs-row> -->
    </vs-card>
    <vs-popup fullscreen title="Graph Settings 1" :active.sync="popupActive1"><br />
      <vs-row>
        <vs-col style="align-items: center" vs-type="flex" vs-lg="6" vs-sm="12" vs-xs="12">
          <a class="mr-2" style="font-size: 0.85rem; color: rgba(0, 0, 0, 0.6)">Project Location</a>
          <vs-select width="300px" v-model="selectMap1">
            <vs-select-item :key="index" :value="item.value" :text="item.name" v-for="(item, index) in optionsLocation" />
          </vs-select></vs-col> </vs-row><br />

      <graphSettingKhonKaen1 v-if="selectMap1 === 'KhonKaen'" :propToGraph1="propToGraph1" :closePopup1="closePopup1"
        :iconMap="sensorKhonKaen" />
      <graphSettingRojana1 v-if="selectMap1 === 'Rojana'" :propToGraph1="propToGraph1" :closePopup1="closePopup1"
        :iconMap="sensorRojana" />
      <graphSettingBangplee1 v-if="selectMap1 === 'Bangplee'" :propToGraph1="propToGraph1" :closePopup1="closePopup1"
        :iconMap="sensorBangplee" />
    </vs-popup>
    <vs-popup fullscreen title="Graph Settings 2" :active.sync="popupActive2"><br />
      <vs-row>
        <vs-col style="align-items: center" vs-type="flex" vs-lg="6" vs-sm="12" vs-xs="12">
          <a class="mr-2" style="font-size: 0.85rem; color: rgba(0, 0, 0, 0.6)">Project Location</a>
          <vs-select width="300px" v-model="selectMap2">
            <vs-select-item :key="index" :value="item.value" :text="item.name" v-for="(item, index) in optionsLocation" />
          </vs-select></vs-col> </vs-row><br />

      <graphSettingKhonKaen2 v-if="selectMap2 === 'KhonKaen'" :propToGraph1="propToGraph2" :closePopup2="closePopup2"
        :iconMap="sensorKhonKaen" />
      <graphSettingRojana2 v-if="selectMap2 === 'Rojana'" :propToGraph1="propToGraph2" :closePopup2="closePopup2"
        :iconMap="sensorRojana" />
      <graphSettingBangplee2 v-if="selectMap2 === 'Bangplee'" :propToGraph1="propToGraph2" :closePopup2="closePopup2"
        :iconMap="sensorBangplee" />
    </vs-popup>
    <vs-popup fullscreen title="Graph Settings 3" :active.sync="popupActive3"><br />
      <vs-row>
        <vs-col style="align-items: center" vs-type="flex" vs-lg="6" vs-sm="12" vs-xs="12">
          <a class="mr-2" style="font-size: 0.85rem; color: rgba(0, 0, 0, 0.6)">Project Location</a>
          <vs-select width="300px" v-model="selectMap3">
            <vs-select-item :key="index" :value="item.value" :text="item.name" v-for="(item, index) in optionsLocation" />
          </vs-select></vs-col> </vs-row><br />

      <graphSettingKhonKaen3 v-if="selectMap3 === 'KhonKaen'" :propToGraph1="propToGraph3" :closePopup3="closePopup3"
        :iconMap="sensorKhonKaen" />
      <graphSettingRojana3 v-if="selectMap3 === 'Rojana'" :propToGraph1="propToGraph3" :closePopup3="closePopup3"
        :iconMap="sensorRojana" />
      <graphSettingBangplee3 v-if="selectMap3 === 'Bangplee'" :propToGraph1="propToGraph3" :closePopup3="closePopup3"
        :iconMap="sensorBangplee" />
    </vs-popup>
    <vs-popup fullscreen title="Graph Settings 4" :active.sync="popupActive4"><br />
      <vs-row>
        <vs-col style="align-items: center" vs-type="flex" vs-lg="6" vs-sm="12" vs-xs="12">
          <a class="mr-2" style="font-size: 0.85rem; color: rgba(0, 0, 0, 0.6)">Project Location</a>
          <vs-select width="300px" v-model="selectMap4">
            <vs-select-item :key="index" :value="item.value" :text="item.name" v-for="(item, index) in optionsLocation" />
          </vs-select></vs-col> </vs-row><br />

      <graphSettingKhonKaen4 v-if="selectMap4 === 'KhonKaen'" :propToGraph1="propToGraph4" :closePopup4="closePopup4"
        :iconMap="sensorKhonKaen" />
      <graphSettingRojana4 v-if="selectMap4 === 'Rojana'" :propToGraph1="propToGraph4" :closePopup4="closePopup4"
        :iconMap="sensorRojana" />
      <graphSettingBangplee4 v-if="selectMap4 === 'Bangplee'" :propToGraph1="propToGraph4" :closePopup4="closePopup4"
        :iconMap="sensorBangplee" />
      <vs-button class="brdbtn" color="dark" @click="closePopup4" type="flat">Cancel</vs-button>
    </vs-popup>
    <vs-popup title="Graph 5: Setting" :active.sync="popupActive5">
      <vs-row>
        <h5>Select Graph</h5>
      </vs-row><br />
      <vs-row>
        <vs-col :key="i" v-for="i in options_graph" vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
          <vs-checkbox v-model="select_option" :vs-value="i.value">{{
            i.text
          }}</vs-checkbox>
        </vs-col>
      </vs-row>
      <br />
      <vs-row>
        <vs-spacer />
        <vs-button class="mr-1 btnBorder" color="success" @click="fillData(select_option)"
          type="filled">Submit</vs-button>
        <vs-button class="btnBorder" @click="popupActive5 = false" color="dark" type="flat">Cancel</vs-button>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import graphSettingRojana1 from "./componentPopup/graph1/mapRojana.vue";
import graphSettingKhonKaen1 from "./componentPopup/graph1/mapKhonKaen.vue";
import graphSettingBangplee1 from "./componentPopup/graph1/mapBangplee.vue";
import graphSettingRojana2 from "./componentPopup/graph2/mapRojana.vue";
import graphSettingKhonKaen2 from "./componentPopup/graph2/mapKhonKaen.vue";
import graphSettingBangplee2 from "./componentPopup/graph2/mapBangplee.vue";
import graphSettingRojana3 from "./componentPopup/graph3/mapRojana.vue";
import graphSettingKhonKaen3 from "./componentPopup/graph3/mapKhonKaen.vue";
import graphSettingBangplee3 from "./componentPopup/graph3/mapBangplee.vue";
import graphSettingRojana4 from "./componentPopup/graph4/mapRojana.vue";
import graphSettingKhonKaen4 from "./componentPopup/graph4/mapKhonKaen.vue";
import graphSettingBangplee4 from "./componentPopup/graph4/mapBangplee.vue";
import Chart from "./componentPopup/Chart.vue";
import lineChart from "./lineChart";
import moment from "moment";
export default {
  components: {
    Chart,
    lineChart,
    graphSettingKhonKaen1,
    graphSettingRojana1,
    graphSettingBangplee1,
    graphSettingKhonKaen2,
    graphSettingRojana2,
    graphSettingBangplee2,
    graphSettingKhonKaen3,
    graphSettingRojana3,
    graphSettingBangplee3,
    graphSettingKhonKaen4,
    graphSettingRojana4,
    graphSettingBangplee4,
  },
  data: () => ({
    testarr: [],
    select1: "",
    popupActive5: false,
    select_option: [],
    temp_option: [],
    options_graph: [
      { text: "Graph 1", value: 1 },
      { text: "Graph 2", value: 2 },
      { text: "Graph 3", value: 3 },
      { text: "Graph 4", value: 4 },
    ],
    chartData1: null,
    chartData2: null,
    chartData3: null,
    chartData4: null,
    chartData5: null,
    selectHeightMap: [],
    test: [],
    selectDevice: [],
    selectLocation: [],
    selectAreaMap: [],
    btnHeigth: "",
    popupActive1: false,
    popupActive2: false,
    popupActive3: false,
    popupActive4: false,
    sensorRojana: [],
    sensorKhonKaen: [],
    sensorBangplee: [],
    select_graph_map: ["Rojana", "Rojana", "Rojana", "Rojana"],
    selectMap1: "Rojana",
    selectMap2: "Rojana",
    selectMap3: "Rojana",
    selectMap4: "Rojana",
    selectMapName: ["", "", "", ""],
    optionsLocation: [
      { name: "Kendall", value: "KhonKaen" },
      { name: "Endeavor", value: "Rojana" },
      { name: "Unicorn", value: "Bangplee" },
    ],
    wGraph: "",
    hGraph: "",

    options1: null,
    options2: null,
    options3: null,
    options4: null,
    options5: null,
    // options: {
    //   responsive: true,
    //   maintainAspectRatio: false,
    // },
    dataGraph1: [],
    dataGraph2: [],
    dataGraph3: [],
    dataGraph4: [],
    temp: [
      {
        maxValTemp: 0,
        minValTemp: 0,
        avgValTemp: 0,
        maxValHumid: 0,
        minValHumid: 0,
        avgValHumid: 0,
      },
      {
        maxValTemp: 0,
        minValTemp: 0,
        avgValTemp: 0,
        maxValHumid: 0,
        minValHumid: 0,
        avgValHumid: 0,
      },
      {
        maxValTemp: 0,
        minValTemp: 0,
        avgValTemp: 0,
        maxValHumid: 0,
        minValHumid: 0,
        avgValHumid: 0,
      },
      {
        maxValTemp: 0,
        minValTemp: 0,
        avgValTemp: 0,
        maxValHumid: 0,
        minValHumid: 0,
        avgValHumid: 0,
      },
      {
        maxValTemp: 0,
        minValTemp: 0,
        avgValTemp: 0,
        maxValHumid: 0,
        minValHumid: 0,
        avgValHumid: 0,
      },
    ],
    sumValTemp: 0,
    a: [],
    dataA: [],
    forgraph5: [
      // { text: "Graph 1", temp: null, humid: null, label: null },
      // { text: "Graph 2", temp: null, humid: null, label: null },
      // { text: "Graph 3", temp: null, humid: null, label: null },
      // { text: "Graph 4", temp: null, humid: null, label: null },
    ],
    tarrBg: [
      "rgba(172, 0, 252,.1)",
      "RGB(139, 0, 204,.1)",
      "RGB(70, 0, 102,.1)",
      "RGB(206, 102, 255,.1)",
    ],
    harrBg: [
      "rgba(20, 153, 242,.1)",
      "RGB(0, 178, 204,.1)",
      "RGB(0, 145, 166,.1)",
      "RGB(0, 223, 255,.1)",
    ],
    tarrB: ["#820401", "#DB4CB2", "#DE542C", "#EE9A3A"],
    harrB: [
      "rgba(20, 153, 242,.9)",
      "#176BA0",
      "#40B5AD",
      "rgba(172, 0, 252,.9)",
    ],
  }),
  methods: {
    fillData(item) {
      this.select_option = item;
      var dataset = [];
      this.testarr = [];
      var summaxValTemp = 0;
      var summinValTemp = 0;
      var summaxValHumid = 0;
      var summinValHumid = 0;
      var sumavgValTemp = 0;
      var sumavgValHumid = 0;
      this.temp[4] = [];
      var maxLength = 0;
      var comparer = "";
      var check = false;
      console.log(this.forgraph5);
      item.forEach((i) => {
        this.forgraph5.forEach((b) => {
          if (i == b.id) {
            this.testarr.push(b);
          }
        });
      });
      console.log(this.testarr);
      this.testarr.forEach((element) => {
        if (element.label.length >= maxLength) maxLength = element.label.length;
      });
      console.log(this.testarr);
      for (let index = 0; index < maxLength; index++) {
        comparer = this.testarr[0].label[index];
        this.testarr.forEach((element) => {
          if (element.label[index] != comparer) {
            check = true;
          }
        });
      }
      this.popupActive5 = false;
      if (check) {
        this.$vs.notify({
          title: "Error",
          text: "Selecting data not matching",
          color: "danger",
          position: "top-center",
        });
        this.chartData5 = {
          labels: [],
          datasets: [],
        };
      } else {
        item.forEach((i) => {
          this.testarr.forEach((b) => {
            summaxValTemp += parseFloat(b.maxValTemp);
            summinValTemp += parseFloat(b.minValTemp);
            summaxValHumid += parseFloat(b.maxValHumid);
            summinValHumid += parseFloat(b.minValHumid);
            sumavgValTemp += parseFloat(b.avgValTemp);
            sumavgValHumid += parseFloat(b.avgValHumid);
          });
        });
        console.log(summaxValTemp / (this.testarr.length * item.length));
        this.temp[4].maxValTemp = (
          summaxValTemp /
          (this.testarr.length * item.length)
        ).toFixed(2);
        this.temp[4].minValTemp = (
          summinValTemp /
          (this.testarr.length * item.length)
        ).toFixed(2);
        this.temp[4].maxValHumid = (
          summaxValHumid /
          (this.testarr.length * item.length)
        ).toFixed(2);
        this.temp[4].minValHumid = (
          summinValHumid /
          (this.testarr.length * item.length)
        ).toFixed(2);
        this.temp[4].avgValTemp = (
          sumavgValTemp /
          (this.testarr.length * item.length)
        ).toFixed(2);
        this.temp[4].avgValHumid = (
          sumavgValHumid /
          (this.testarr.length * item.length)
        ).toFixed(2);
        this.testarr.forEach((element, i) => {
          dataset.push(
            {
              label: "Temp(°C) " + this.testarr[i].text,
              type: "line",
              data: this.testarr[i].temp,
              borderColor: this.tarrB[i],
              backgroundColor: "RGB(252, 234, 230,.1)",
              borderWidth: 3,
            },
            {
              label: "Humidity(%) " + this.testarr[i].text,
              type: "line",
              data: this.testarr[i].humid,
              borderColor: this.harrB[i],
              backgroundColor: "RGB(199, 249, 238,.1)",
              borderWidth: 3,
            }
          );
        });
        // console.log(dataset);
        this.chartData5 = {
          labels: this.testarr[0].label,
          datasets: dataset,
        };
        this.options5 = {
          maintainAspectRatio: false,
          responsive: true,
          legend: {
            position: "bottom",
          },
          scales: {
            yAxes: [
              {
                id: "A",
                beginAtZero: true,
                position: "left",
                scaleLabel: {
                  display: true,
                  labelString: "Temperature (C)",
                },
              },
            ],
            xAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
                scaleLabel: {
                  display: true,
                  labelString: "Timestamp",
                },
              },
            ],
          },
        };
      }
    },
    getRandomColor() {
      var color = "hsl(" + Math.random() * 360 + ", 100%, 40%)";
      return color;
    },
    lender1(item) {
      let popIndex;
      let check = false;
      this.forgraph5.forEach((element, index) => {
        if (element.text == "Graph 1") {
          popIndex = index;
          check = true;
        }
      });
      if (check) this.forgraph5.splice(popIndex, 1);
      let itemTemp = [];
      let itemHumid = [];
      let sumValTemp = 0;
      let sumValHumid = 0;

      this.temp[0].maxValTemp = Math.max.apply(Math, item.temp);
      this.temp[0].minValTemp = Math.min.apply(Math, item.temp);
      this.temp[0].maxValHumid = Math.max.apply(Math, item.humid);
      this.temp[0].minValHumid = Math.min.apply(Math, item.humid);
      itemTemp = item.temp.map((i) => Number(i));
      itemHumid = item.humid.map((i) => Number(i));
      for (var i = 0; i < itemTemp.length; i++) {
        sumValTemp += itemTemp[i];
      }
      this.temp[0].avgValTemp = (sumValTemp / itemTemp.length).toFixed(2);
      for (var i = 0; i < itemHumid.length; i++) {
        sumValHumid += itemHumid[i];
      }
      this.temp[0].avgValHumid = (sumValHumid / itemHumid.length).toFixed(2);

      this.chartData1 = {
        labels: item.label,
        datasets: [
          {
            label: "Temperature ( °C )",
            backgroundColor: "rgba(172, 0, 252,.1)",
            data: item.temp,
            borderWidth: 1.5,
            borderColor: "rgba(172, 0, 252,.9)",
          },
          {
            label: "Humidity ( % )",
            data: item.humid,
            backgroundColor: "rgba(20, 153, 242,.1)",
            borderWidth: 1.5,
            borderColor: "rgba(20, 153, 242,.9)",
          },
        ],
      };
      this.forgraph5.push({
        id: 1,
        text: "Graph 1",
        temp: item.temp,
        humid: item.humid,
        label: item.label,
        maxValTemp: this.temp[0].maxValTemp,
        minValTemp: this.temp[0].minValTemp,
        maxValHumid: this.temp[0].maxValHumid,
        minValHumid: this.temp[0].minValHumid,
        avgValTemp: this.temp[0].avgValTemp,
        avgValHumid: this.temp[0].avgValHumid,
      });
      this.options1 = {
        responsive: true,
        legend: {
          position: "bottom",
        },
        scales: {
          yAxes: [
            {
              id: "A",
              beginAtZero: true,
              position: "left",
              scaleLabel: {
                display: true,
                labelString: "Temperature (C)",
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: "Timestamp",
              },
            },
          ],
        },
      };
    },
    lender2(item) {
      let popIndex;
      let check = false;
      this.forgraph5.forEach((element, index) => {
        if (element.text == "Graph 2") {
          popIndex = index;
          check = true;
        }
      });
      if (check) this.forgraph5.splice(popIndex, 1);
      let itemTemp = [];
      let itemHumid = [];
      let sumValTemp = 0;
      let sumValHumid = 0;

      this.temp[1].maxValTemp = Math.max.apply(Math, item.temp);
      this.temp[1].minValTemp = Math.min.apply(Math, item.temp);
      this.temp[1].maxValHumid = Math.max.apply(Math, item.humid);
      this.temp[1].minValHumid = Math.min.apply(Math, item.humid);
      itemTemp = item.temp.map((i) => Number(i));
      itemHumid = item.humid.map((i) => Number(i));
      for (var i = 0; i < itemTemp.length; i++) {
        sumValTemp += itemTemp[i];
      }
      this.temp[1].avgValTemp = (sumValTemp / itemTemp.length).toFixed(2);
      for (var i = 0; i < itemHumid.length; i++) {
        sumValHumid += itemHumid[i];
      }
      this.temp[1].avgValHumid = (sumValHumid / itemHumid.length).toFixed(2);
      this.chartData2 = {
        labels: item.label,
        datasets: [
          {
            label: "Temperature ( °C )",
            backgroundColor: "rgba(172, 0, 252,.1)",
            data: item.temp,
            borderWidth: 1.5,
            borderColor: "rgba(172, 0, 252,.9)",
          },
          {
            label: "Humidity ( % )",
            data: item.humid,
            backgroundColor: "rgba(20, 153, 242,.1)",
            borderWidth: 1.5,
            borderColor: "rgba(20, 153, 242,.9)",
          },
        ],
      };
      this.forgraph5.push({
        id: 2,
        text: "Graph 2",
        temp: item.temp,
        humid: item.humid,
        label: item.label,
        maxValTemp: this.temp[1].maxValTemp,
        minValTemp: this.temp[1].minValTemp,
        maxValHumid: this.temp[1].maxValHumid,
        minValHumid: this.temp[1].minValHumid,
        avgValTemp: this.temp[1].avgValTemp,
        avgValHumid: this.temp[1].avgValHumid,
      });
      this.options2 = {
        responsive: true,
        legend: {
          position: "bottom",
        },
        scales: {
          yAxes: [
            {
              id: "A",
              beginAtZero: true,
              position: "left",
              scaleLabel: {
                display: true,
                labelString: "Temperature (C)",
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: "Timestamp",
              },
            },
          ],
        },
      };
    },
    lender3(item) {
      let popIndex;
      let check = false;
      this.forgraph5.forEach((element, index) => {
        if (element.text == "Graph 3") {
          popIndex = index;
          check = true;
        }
      });
      if (check) this.forgraph5.splice(popIndex, 1);
      let itemTemp = [];
      let itemHumid = [];
      let sumValTemp = 0;
      let sumValHumid = 0;

      this.temp[2].maxValTemp = Math.max.apply(Math, item.temp);
      this.temp[2].minValTemp = Math.min.apply(Math, item.temp);
      this.temp[2].maxValHumid = Math.max.apply(Math, item.humid);
      this.temp[2].minValHumid = Math.min.apply(Math, item.humid);
      itemTemp = item.temp.map((i) => Number(i));
      itemHumid = item.humid.map((i) => Number(i));
      for (var i = 0; i < itemTemp.length; i++) {
        sumValTemp += itemTemp[i];
      }
      this.temp[2].avgValTemp = (sumValTemp / itemTemp.length).toFixed(2);
      for (var i = 0; i < itemHumid.length; i++) {
        sumValHumid += itemHumid[i];
      }
      this.temp[2].avgValHumid = (sumValHumid / itemHumid.length).toFixed(2);
      this.chartData3 = {
        labels: item.label,
        datasets: [
          {
            label: "Temperature ( °C )",
            backgroundColor: "rgba(172, 0, 252,.1)",
            data: item.temp,
            borderWidth: 1.5,
            borderColor: "rgba(172, 0, 252,.9)",
          },
          {
            label: "Humidity ( % )",
            data: item.humid,
            backgroundColor: "rgba(20, 153, 242,.1)",
            borderWidth: 1.5,
            borderColor: "rgba(20, 153, 242,.9)",
          },
        ],
      };
      this.forgraph5.push({
        id: 3,
        text: "Graph 3",
        temp: item.temp,
        humid: item.humid,
        label: item.label,
        maxValTemp: this.temp[2].maxValTemp,
        minValTemp: this.temp[2].minValTemp,
        maxValHumid: this.temp[2].maxValHumid,
        minValHumid: this.temp[2].minValHumid,
        avgValTemp: this.temp[2].avgValTemp,
        avgValHumid: this.temp[2].avgValHumid,
      });
      this.options3 = {
        responsive: true,
        legend: {
          position: "bottom",
        },
        scales: {
          yAxes: [
            {
              id: "A",
              beginAtZero: true,
              position: "left",
              scaleLabel: {
                display: true,
                labelString: "Temperature (C)",
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: "Timestamp",
              },
            },
          ],
        },
      };
    },
    lender4(item) {
      let popIndex;
      let check = false;
      this.forgraph5.forEach((element, index) => {
        if (element.text == "Graph 4") {
          popIndex = index;
          check = true;
        }
      });
      if (check) this.forgraph5.splice(popIndex, 1);
      let itemTemp = [];
      let itemHumid = [];
      let sumValTemp = 0;
      let sumValHumid = 0;
      this.temp[3].maxValTemp = Math.max.apply(Math, item.temp);
      this.temp[3].minValTemp = Math.min.apply(Math, item.temp);
      this.temp[3].maxValHumid = Math.max.apply(Math, item.humid);
      this.temp[3].minValHumid = Math.min.apply(Math, item.humid);
      itemTemp = item.temp.map((i) => Number(i));
      itemHumid = item.humid.map((i) => Number(i));
      for (var i = 0; i < itemTemp.length; i++) {
        sumValTemp += itemTemp[i];
      }
      this.temp[3].avgValTemp = (sumValTemp / itemTemp.length).toFixed(2);
      for (var i = 0; i < itemHumid.length; i++) {
        sumValHumid += itemHumid[i];
      }
      this.temp[3].avgValHumid = (sumValHumid / itemHumid.length).toFixed(2);
      this.chartData4 = {
        labels: item.label,
        datasets: [
          {
            label: "Temperature ( °C )",
            backgroundColor: "rgba(172, 0, 252,.1)",
            data: item.temp,
            borderWidth: 1.5,
            borderColor: "rgba(172, 0, 252,.9)",
          },
          {
            label: "Humidity ( % )",
            data: item.humid,
            backgroundColor: "rgba(20, 153, 242,.1)",
            borderWidth: 1.5,
            borderColor: "rgba(20, 153, 242,.9)",
          },
        ],
      };
      this.forgraph5.push({
        id: 4,
        text: "Graph 4",
        temp: item.temp,
        humid: item.humid,
        label: item.label,
        maxValTemp: this.temp[3].maxValTemp,
        minValTemp: this.temp[3].minValTemp,
        maxValHumid: this.temp[3].maxValHumid,
        minValHumid: this.temp[3].minValHumid,
        avgValTemp: this.temp[3].avgValTemp,
        avgValHumid: this.temp[3].avgValHumid,
      });
      this.options4 = {
        responsive: true,
        legend: {
          position: "bottom",
        },
        scales: {
          yAxes: [
            {
              id: "A",
              beginAtZero: true,
              position: "left",
              scaleLabel: {
                display: true,
                labelString: "Temperature (C)",
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: "Timestamp",
              },
            },
          ],
        },
      };
    },
    propToGraph1(item) {
      console.log(item);
      this.dataGraph1 = item;
      var body = item;
      Object.assign(body, { location: this.selectMap1 });
      // this.dataGraph1.push({location: this.selectMap1})
      console.log(body);
      this.$API.put(`dashboard/setting/graph/1`, body).then((result) => { });
      this.$API.post(`frasers/chart`, body).then((result) => {
        this.closePopup1();
        this.lender1(result.data);
      });
    },
    propToGraph2(item) {
      console.log(item);
      this.dataGraph2 = item;
      var body = item;
      Object.assign(body, { location: this.selectMap2 });
      console.log(body);
      this.$API.put(`dashboard/setting/graph/2`, body).then((result) => {
        console.log(result.data);
      });
      this.$API.post(`frasers/chart`, body).then((result) => {
        console.log(result.data);
        this.closePopup2();
        this.lender2(result.data);
      });
    },
    propToGraph3(item) {
      console.log(item);
      this.dataGraph3 = item;
      var body = item;
      Object.assign(body, { location: this.selectMap3 });
      console.log(body);
      this.$API.put(`dashboard/setting/graph/3`, body).then((result) => {
        console.log(result.data);
      });
      this.$API.post(`frasers/chart`, body).then((result) => {
        console.log(result.data);
        this.closePopup3();
        this.lender3(result.data);
      });
    },
    propToGraph4(item) {
      console.log(item);
      this.dataGraph4 = item;
      var body = item;
      Object.assign(body, { location: this.selectMap4 });
      console.log(body);
      this.$API.put(`dashboard/setting/graph/4`, body).then((result) => {
        console.log(result.data);
      });
      this.$API.post(`frasers/chart`, body).then((result) => {
        console.log(result.data);
        this.closePopup4();
        this.lender4(result.data);
      });
    },
    closePopup1() {
      this.popupActive1 = false;
      // console.log(this.popupActive1);
    },
    closePopup2() {
      this.popupActive2 = false;
    },
    closePopup3() {
      this.popupActive3 = false;
    },
    closePopup4() {
      this.popupActive4 = false;
    },
  },
  async mounted() {

    this.$vs.loading();
    await Promise.all([
      this.$API.get(`sensor/network/145/frasers`),
      this.$API.get(`sensor/network/115/frasers`),
      this.$API.get(`sensor/network/146/frasers`)
    ]).then(([sensor_rojana, sensor_khonKaen, sensor_bangplee]) => {

      // getSensorRojana
      sensor_rojana.data.forEach(async (element) => {
        if (element.location != "Outside") {
          let filteredData = sensor_rojana.data.filter(
            (data) => data.location == element.location
          );
          element.avgTemp = (
            filteredData.reduce((total, next) => total + next.temperature, 0) /
            filteredData.length
          ).toFixed(1);
          element.avgHumd = (
            filteredData.reduce((total, next) => total + next.humidity, 0) /
            filteredData.length
          ).toFixed(1);
          element.nameTempA = element.temperature;
          //compute temperature&humdity by location
          element.selectLocationTemp = [];
          element.selectLocationHumd = [];
          await filteredData.forEach((data) => {
            element.selectLocationTemp.push(
              data.name + " Temperature : " + data.temperature + "°C \n"
            );
            element.selectLocationHumd.push(data.humidity);
          });
        } else {
          element.avgTemp = element.temperature.toFixed(1);
        }
      });
      this.sensorRojana = sensor_rojana.data;

      // getSensorKhonKaen
      sensor_khonKaen.data.forEach(async (element) => {
        if (element.location != "Outside") {
          let filteredData = sensor_khonKaen.data.filter(
            (data) => data.location == element.location
          );
          element.avgTemp = (
            filteredData.reduce((total, next) => total + next.temperature, 0) /
            filteredData.length
          ).toFixed(1);
          element.avgHumd = (
            filteredData.reduce((total, next) => total + next.humidity, 0) /
            filteredData.length
          ).toFixed(1);
          element.nameTempA = element.temperature;
          //compute temperature&humdity by location
          element.selectLocationTemp = [];
          element.selectLocationHumd = [];
          await filteredData.forEach((data) => {
            element.selectLocationTemp.push(
              data.name + " Temperature : " + data.temperature + "°C \n"
            );
            element.selectLocationHumd.push(data.humidity);
          });
        } else {
          element.avgTemp = element.temperature.toFixed(1);
        }
      });
      this.sensorKhonKaen = sensor_khonKaen.data;

      // getSensorBangplee
      sensor_bangplee.data.forEach(async (element) => {
        if (element.location != "Outside") {
          let filteredData = sensor_bangplee.data.filter(
            (data) => data.location == element.location
          );
          element.avgTemp = (
            filteredData.reduce((total, next) => total + next.temperature, 0) /
            filteredData.length
          ).toFixed(1);
          element.avgHumd = (
            filteredData.reduce((total, next) => total + next.humidity, 0) /
            filteredData.length
          ).toFixed(1);
          element.nameTempA = element.temperature;
          //compute temperature&humdity by location
          element.selectLocationTemp = [];
          element.selectLocationHumd = [];
          await filteredData.forEach((data) => {
            element.selectLocationTemp.push(
              data.name + " Temperature : " + data.temperature + "°C \n"
            );
            element.selectLocationHumd.push(data.humidity);
          });
        } else {
          element.avgTemp = element.temperature.toFixed(1);
        }
      });
      this.sensorBangplee = sensor_bangplee.data;
    })

    // // getSensorRojana
    // await this.$API.get(`sensor/network/145/frasers`).then((result) => {
    //   result.data.forEach(async (element) => {
    //     if (element.location != "Outside") {
    //       let filteredData = result.data.filter(
    //         (data) => data.location == element.location
    //       );
    //       element.avgTemp = (
    //         filteredData.reduce((total, next) => total + next.temperature, 0) /
    //         filteredData.length
    //       ).toFixed(1);
    //       element.avgHumd = (
    //         filteredData.reduce((total, next) => total + next.humidity, 0) /
    //         filteredData.length
    //       ).toFixed(1);
    //       element.nameTempA = element.temperature;
    //       //compute temperature&humdity by location
    //       element.selectLocationTemp = [];
    //       element.selectLocationHumd = [];
    //       await filteredData.forEach((data) => {
    //         element.selectLocationTemp.push(
    //           data.name + " Temperature : " + data.temperature + "°C \n"
    //         );
    //         element.selectLocationHumd.push(data.humidity);
    //       });
    //     } else {
    //       element.avgTemp = element.temperature.toFixed(1);
    //     }
    //   });
    //   this.sensorRojana = result.data;
    // });
    // // getSensorKhonKaen
    // await this.$API.get(`sensor/network/115/frasers`).then((result) => {
    //   result.data.forEach(async (element) => {
    //     if (element.location != "Outside") {
    //       let filteredData = result.data.filter(
    //         (data) => data.location == element.location
    //       );
    //       element.avgTemp = (
    //         filteredData.reduce((total, next) => total + next.temperature, 0) /
    //         filteredData.length
    //       ).toFixed(1);
    //       element.avgHumd = (
    //         filteredData.reduce((total, next) => total + next.humidity, 0) /
    //         filteredData.length
    //       ).toFixed(1);
    //       element.nameTempA = element.temperature;
    //       //compute temperature&humdity by location
    //       element.selectLocationTemp = [];
    //       element.selectLocationHumd = [];
    //       await filteredData.forEach((data) => {
    //         element.selectLocationTemp.push(
    //           data.name + " Temperature : " + data.temperature + "°C \n"
    //         );
    //         element.selectLocationHumd.push(data.humidity);
    //       });
    //     } else {
    //       element.avgTemp = element.temperature.toFixed(1);
    //     }
    //   });
    //   this.sensorKhonKaen = result.data;
    // });
    // // getSensorBangplee
    // await this.$API.get(`sensor/network/146/frasers`).then((result) => {
    //   result.data.forEach(async (element) => {
    //     if (element.location != "Outside") {
    //       let filteredData = result.data.filter(
    //         (data) => data.location == element.location
    //       );
    //       element.avgTemp = (
    //         filteredData.reduce((total, next) => total + next.temperature, 0) /
    //         filteredData.length
    //       ).toFixed(1);
    //       element.avgHumd = (
    //         filteredData.reduce((total, next) => total + next.humidity, 0) /
    //         filteredData.length
    //       ).toFixed(1);
    //       element.nameTempA = element.temperature;
    //       //compute temperature&humdity by location
    //       element.selectLocationTemp = [];
    //       element.selectLocationHumd = [];
    //       await filteredData.forEach((data) => {
    //         element.selectLocationTemp.push(
    //           data.name + " Temperature : " + data.temperature + "°C \n"
    //         );
    //         element.selectLocationHumd.push(data.humidity);
    //       });
    //     } else {
    //       element.avgTemp = element.temperature.toFixed(1);
    //     }
    //   });
    //   this.sensorBangplee = result.data;
    // });

    await Promise.all([
      this.$API.get(`dashboard/setting/graph/1`),
      this.$API.get(`dashboard/setting/graph/2`),
      this.$API.get(`dashboard/setting/graph/3`),
      this.$API.get(`dashboard/setting/graph/4`)
    ]).then(async ([graph1, graph2, graph3, graph4]) => {

      let start_date = moment().startOf('month')
      let end_date = moment().endOf('month')
      // Graph1
      this.dataGraph1 = graph1.data;
      this.selectMap1 = graph1.data[0].location;
      console.log(this.selectMap1);
      switch (this.selectMap1) {
        case "KhonKaen":
          this.selectMapName[0] = "Kendall";
          break;
        case "Rojana":
          this.selectMapName[0] = "Endeavor";
          break;
        case "Bangplee":
          this.selectMapName[0] = "Unicorn";
          break;
      }
      console.log(graph1.data);
      var graph1_body = {
        title: "graph1",
        device_id: graph1.data[0].device_id,
        start_date: graph1.data[0].start_date,
        end_date: graph1.data[0].end_date,
      };
      // await this.$API.post(`frasers/chart`, graph1_body).then(async (graph1_result) => {
      //   await this.lender1(graph1_result.data);
      // });

      // Graph2
      this.dataGraph2 = graph2.data;
      console.log(graph2.data);
      this.selectMap2 = graph2.data[0].location;
      switch (this.selectMap2) {
        case "KhonKaen":
          this.selectMapName[1] = "Kendall";
          break;
        case "Rojana":
          this.selectMapName[1] = "Endeavor";
          break;
        case "Bangplee":
          this.selectMapName[1] = "Unicorn";
          break;
      }
      var graph2_body = {
        title: "graph2",
        device_id: graph2.data[0].device_id,
        start_date: graph2.data[0].start_date,
        end_date: graph2.data[0].end_date,
      };
      // await this.$API.post(`frasers/chart`, graph2_body).then(async (graph2_result) => {
      //   await this.lender2(graph2_result.data);
      // });

      // Graph3
      this.dataGraph3 = graph3.data;
      console.log(graph3.data);
      this.selectMap3 = graph3.data[0].location;
      switch (this.selectMap3) {
        case "KhonKaen":
          this.selectMapName[2] = "Kendall";
          break;
        case "Rojana":
          this.selectMapName[2] = "Endeavor";
          break;
        case "Bangplee":
          this.selectMapName[2] = "Unicorn";
          break;
      }
      var graph3_body = {
        title: "graph3",
        device_id: graph3.data[0].device_id,
        start_date: graph3.data[0].start_date,
        end_date: graph3.data[0].end_date,
      };
      // await this.$API.post(`frasers/chart`, graph3_body).then(async (graph3_result) => {
      //   await this.lender3(graph3_result.data);
      // });

      // Graph4
      this.dataGraph4 = graph4.data;
      console.log(graph4.data);
      this.selectMap4 = graph4.data[0].location;
      switch (this.selectMap4) {
        case "KhonKaen":
          this.selectMapName[3] = "Kendall";
          break;
        case "Rojana":
          this.selectMapName[3] = "Endeavor";
          break;
        case "Bangplee":
          this.selectMapName[3] = "Unicorn";
          break;
      }
      var graph4_body = {
        title: "graph4",
        device_id: graph4.data[0].device_id,
        start_date: graph4.data[0].start_date,
        end_date: graph4.data[0].end_date,
      };
      // await this.$API.post(`frasers/chart`, graph4_body).then(async (graph4_result) => {
      //   await this.lender4(graph4_result.data);
      // });

      // renderChart
      await Promise.all([
        this.$API.post(`frasers/chart`, graph1_body).then(async (graph1_result) => { await this.lender1(graph1_result.data); }),
        this.$API.post(`frasers/chart`, graph2_body).then(async (graph2_result) => { await this.lender2(graph2_result.data); }),
        this.$API.post(`frasers/chart`, graph3_body).then(async (graph3_result) => { await this.lender3(graph3_result.data); }),
        this.$API.post(`frasers/chart`, graph4_body).then(async (graph4_result) => { await this.lender4(graph4_result.data); })
      ])
      // .then(async ([graph1_result,graph2_result,graph3_result,graph4_result,]) => {
      //   await this.lender1(graph1_result.data);
      //   await this.lender2(graph2_result.data);
      //   await this.lender3(graph3_result.data);
      //   await this.lender4(graph4_result.data);

      // })
    })


    // await this.$API.get(`dashboard/setting/graph/1`).then(async (result) => {
    //   this.dataGraph1 = result.data;
    //   this.selectMap1 = result.data[0].location;
    //   console.log(this.selectMap1);
    //   switch (this.selectMap1) {
    //     case "KhonKaen":
    //       this.selectMapName[0] = "Kendall";
    //       break;
    //     case "Rojana":
    //       this.selectMapName[0] = "Endeavor";
    //       break;
    //     case "Bangplee":
    //       this.selectMapName[0] = "Unicorn";
    //       break;
    //   }
    //   console.log(result.data);
    //   var body3 = {
    //     device_id: result.data[0].device_id,
    //     start_date: result.data[0].start_date,
    //     end_date: result.data[0].end_date,
    //   };
    //   await this.$API.post(`frasers/chart`, body3).then(async (result2) => {
    //     await this.lender1(result2.data);
    //   });
    // });
    // await this.$API.get(`dashboard/setting/graph/2`).then(async (result) => {
    //   this.dataGraph2 = result.data;
    //   console.log(result.data);
    //   this.selectMap2 = result.data[0].location;
    //   switch (this.selectMap2) {
    //     case "KhonKaen":
    //       this.selectMapName[1] = "Kendall";
    //       break;
    //     case "Rojana":
    //       this.selectMapName[1] = "Endeavor";
    //       break;
    //     case "Bangplee":
    //       this.selectMapName[1] = "Unicorn";
    //       break;
    //   }
    //   var body3 = {
    //     device_id: result.data[0].device_id,
    //     start_date: result.data[0].start_date,
    //     end_date: result.data[0].end_date,
    //   };
    //   await this.$API.post(`frasers/chart`, body3).then(async (result2) => {
    //     await this.lender2(result2.data);
    //   });
    // });
    // await this.$API.get(`dashboard/setting/graph/3`).then(async (result) => {
    //   this.dataGraph3 = result.data;
    //   console.log(result.data);
    //   this.selectMap3 = result.data[0].location;
    //   switch (this.selectMap3) {
    //     case "KhonKaen":
    //       this.selectMapName[2] = "Kendall";
    //       break;
    //     case "Rojana":
    //       this.selectMapName[2] = "Endeavor";
    //       break;
    //     case "Bangplee":
    //       this.selectMapName[2] = "Unicorn";
    //       break;
    //   }
    //   var body3 = {
    //     device_id: result.data[0].device_id,
    //     start_date: result.data[0].start_date,
    //     end_date: result.data[0].end_date,
    //   };
    //   await this.$API.post(`frasers/chart`, body3).then(async (result2) => {
    //     console.log(result2.data);
    //     await this.lender3(result2.data);
    //   });
    // });
    // await this.$API.get(`dashboard/setting/graph/4`).then(async (result) => {
    //   this.dataGraph4 = result.data;
    //   console.log(result.data);
    //   this.selectMap4 = result.data[0].location;
    //   switch (this.selectMap4) {
    //     case "KhonKaen":
    //       this.selectMapName[3] = "Kendall";
    //       break;
    //     case "Rojana":
    //       this.selectMapName[3] = "Endeavor";
    //       break;
    //     case "Bangplee":
    //       this.selectMapName[3] = "Unicorn";
    //       break;
    //   }
    //   var body3 = {
    //     device_id: result.data[0].device_id,
    //     start_date: result.data[0].start_date,
    //     end_date: result.data[0].end_date,
    //   };
    //   await this.$API.post(`frasers/chart`, body3).then(async (result2) => {
    //     console.log(result2.data);
    //     await this.lender4(result2.data);
    //   });
    // });

    // this.propToGraph1(this.dataGraph1);
    // this.$API.post(`frasers/chart`, body).then((result) => {
    //   // this.closePopup1();
    //   console.log(result.data);
    //   this.da2 = result.data.humid;
    //   this.da = result.data.temp;
    //   this.labels = result.data.label;
    // });
    this.$vs.loading.close();
  },
  created() {
    // console.log(window.innerWidth);
    if (window.innerWidth < 1550) {
      this.wGraph = 420;
    } else if (window.innerWidth > 1550) {
      this.wGraph = 610;
    }
  },
};
</script>

<style scoped>
.btnBorder {
  border-radius: 20px;
  width: 90px;
}

.padding0 {
  padding: 0;
}

.vdatetime-input {
  border-radius: 20px;
  width: 100%;
  color: inherit;
  position: relative;
  padding: 0.4rem;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);
  box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  width: 100%;
}

.flex-container {
  display: flex;
  flex-direction: row;
  /* font-size: 30px; */
  text-align: center;
}

.flex-item-left {
  /* background-color: #f1f1f1; */
  /* padding: 10px; */
  flex: 50%;
}

.flex-item-right {
  /* background-color: dodgerblue; */
  /* padding: 10px; */
  flex: 50%;
}

.carddetail {
  height: 80%;
  margin: 10%;
  padding-top: 20px;
  border-radius: 20px;
  text-align: center;
  background: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}

/* Responsive layout - makes a one column-layout instead of two-column layout */
@media (max-width: 1400px) {
  .flex-container {
    flex-direction: column;
  }
}
</style>
